import { useToast } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { ApplicationState } from './store';
import { clearToast } from './store/ui/actions';

export default function ToastContainerWrap(): React.JSX.Element {
  const toast = useToast();
  const dispatch = useDispatch();
  const toastProps = useSelector((state: ApplicationState) => state.ui.toastProps);
  useEffect(() => {
    if (toastProps) {
      toast(toastProps);
      dispatch(clearToast());
    }
  }, [toastProps]);
  return <ToastContainer />;
}
